export type ProductOfferType = 'HIGH_YIELD_CD' | 'NO_PENALTY_CD' | 'SAVINGS_ACCOUNT';
export type MaturityType = 'DAYS' | 'MONTHS' | 'YEARS';

export const financialInstitutionMap = {
  Bank: 'Bank',
  CreditUnion: 'Credit Union',
  NotForProfit: 'Not-for-profit',
  CommunityDevelopment: 'Community development',
  MinorityLed: 'Minority-led',
  FamilyOwned: 'Family-owned',
  SupportsSmallBusiness: 'Supports small business',
  EducationFinancing: 'Education financing',
  DigitalFirst: 'Digital-first',
  GivesBack: 'Gives back',
  LocalFocus: 'Local focus',
} as const;
export type FinancialInstitutionType = keyof typeof financialInstitutionMap;

export type Maturity = {
  duration: number;
  unit: MaturityType;
};

export interface USProductOffer {
  id: string;
  type: ProductOfferType;
  name: string;
  apy: number;
  teaserApy?: number;
  teaserPeriodInDays?: number;
  teaserStatus?: 'ACTIVE' | 'INACTIVE';
  minAmount: number;
  productBank: {
    id: string;
    name: string;
    logoUrl: string;
  };
  maturity?: Maturity;
}

export interface USProductOfferDocument {
  id?: string;
  content?: string;
}

export type ProductOfferListItem = {
  id: string;
  type: ProductOfferType;
  productName: string;
  standardApy: number;
  bankId: string;
  teaserApy?: number;
  teaserPeriodInDays?: number;
  teaserStatus?: 'ACTIVE' | 'INACTIVE';
  bankName: string;
  bankLogo: string;
  maturityUnits: MaturityType;
  maturityDuration: number;
  financialInstitutions: FinancialInstitutionType[];
};

export type USProductOfferTableProps = {
  productOffers: Array<USProductOffer>;
  bankId?: string;
  productId?: string;
  bankLogoLinks?: Record<string, string>;
  featuredProducts?: string[];
  inactiveProducts?: string[];
  categoryTabsToShow?: string[];
  financialInstitutions?: Record<string, FinancialInstitutionType[]>;
  showFinancialInstitutionsDropdown?: boolean;
};
